import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenDocumentsComponent } from './screen-documents.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { ScreenVideosComponent } from './screen-videos/screen-videos.component';
import { VideoItemComponent } from './screen-videos/video-item/video-item.component';
import { VideoUploadComponent } from './screen-videos/video-upload/video-upload.component';

@NgModule({
  declarations: [
    ScreenDocumentsComponent,
    ScreenVideosComponent,
    VideoItemComponent,
    VideoUploadComponent],
  exports: [ScreenDocumentsComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule]
})
export class ScreenDocsModule {}
